import { useEffect, useState, useRef } from 'react';
import { withFormik } from 'formik';
import classNames from 'classnames';
import { Button, Row, Col, Form } from 'react-bootstrap';
import { format, parse, add, startOfDay } from 'date-fns';
import { withStore } from 'store';
import { ShareLink, PrintQR } from 'components/Cards';
import { updateGiftTable } from 'store/actions/giftTable';
import { UploadImageModal } from 'components/gifts-table';
import uploadIcon from 'assets/img/upload-icon.svg';
import iconEdit from 'assets/img/icon_edit.svg';
import { fetchEventTypes } from 'store/actions/catalogs';
import { FLAT } from 'constants/transformers';
import styles from './styles.module.scss';
import { getTableDate } from './utils';
import TableWelcomeMessage from 'components/gifts-table/TableWelcomeMessage';

const TableHeroMobile = ({
  typeId,
  onSave,
  readOnly = false,
  onDeleteHero,
  values,
  setFieldValue,
  showTableInfoData = false,
  tableInfo = {},
  eventIcon = '',
  dispatch,
  eventTypes,
  ...props
}) => {
  const {
    image,
    eventName,
    name,
    date: tableInfoDate,
  } = showTableInfoData ? tableInfo : props;

  const [icon, setIcon] = useState(eventIcon);
  const [editTitle, setEditTitle] = useState(false);
  const [editDate, setEditDate] = useState(false);
  const [tableName, setTableName] = useState(name);
  const [tableDate, setTableDate] = useState(tableInfoDate);
  const [showUploadImage, setShowUploadImage] = useState(false);
  const [minDate, setMinDate] = useState(new Date());
  const [errorDate, setErrorDate] = useState(false);

  const date = getTableDate(tableDate);
  const titleRef = useRef(null);
  const dateRef = useRef({});

  const saveTitle = (element) => {
    if (element.target.value) {
      const payload = { gift_table: { name: element.target.value } };
      dispatch(updateGiftTable(payload));
      setTableName(element.target.value);
    }

    setEditTitle(false);
  };

  const saveDate = (element) => {
    if (element.target.value) {
      const newDate = parse(element.target.value, 'yyyy-MM-dd', new Date());
      const eventDate = format(newDate, 'yyyyMMdd');
      if (newDate >= minDate) {
        setErrorDate(false);
        const payload = { event_date: eventDate };
        dispatch(updateGiftTable(payload));
        setTableDate(format(newDate, 'yyyy-MM-dd 00:00:00'));
        setEditDate(false);
      } else {
        setErrorDate(true);
      }
    }
  };

  const handleClickUploadImage = () => {
    setShowUploadImage(true);
  };

  const handleCloseUploadImage = () => {
    setShowUploadImage(false);
  };

  useEffect(() => {
    if (eventTypes) {
      const eventTypeInfo = eventTypes.find(
        (eventType) => eventType.id === typeId
      );
      setIcon((currentIcon) =>
        eventTypeInfo ? eventTypeInfo.image : currentIcon
      );
      setMinDate((currentDays) =>
        eventTypeInfo
          ? startOfDay(
              add(new Date(), {
                days: 1 + parseInt(eventTypeInfo.restriction_days, 10),
              })
            )
          : currentDays
      );
    }
  }, [eventTypes, typeId]);

  useEffect(() => {
    dispatch(fetchEventTypes(false, true, FLAT));
  }, []);

  useEffect(() => {
    if (editTitle) {
      titleRef.current.focus();
    }
  }, [editTitle]);

  useEffect(() => {
    if (name) {
      setTableName(name);
    }
  }, [name]);

  useEffect(() => {
    if (tableInfoDate) {
      let tmpDate = tableInfoDate;
      if (tableInfoDate.length === 8) {
        tmpDate = `${tmpDate.substring(0, 4)}-${tmpDate.substring(
          4,
          6
        )}-${tmpDate.substring(6, 8)} 00:00:00`;
      }
      setTableDate(tmpDate);
    }
  }, [tableInfoDate]);

  const saveField = (values) => {
    dispatch(updateGiftTable(values));
  };

  localStorage.setItem('icon', icon);
  //console.log('icon: ',icon);
  return (
    <>
      <UploadImageModal
        show={showUploadImage}
        onClose={handleCloseUploadImage}
        loader={false}
      />

      {/* seccion botones subir foto,QR y compartir mobile */}
      <div
        className={`${styles.TableHero__ActionIcons} justify-content-between justify-content-md-end`}
      >
        {!readOnly && (
          <div
            className={`${styles.uploadPhotoIcon} d-md-none`}
            onClick={handleClickUploadImage}
            onKeyDown={handleClickUploadImage}
            role="button"
            tabIndex="0"
          >
            <img src={uploadIcon} alt="Subir foto2" />
          </div>
        )}
      </div>
      <div className={styles.TableHero_controls}>
      {!readOnly && (
          <div className={`${styles.shareGiftTableMini} d-md-none`}>
            <PrintQR variant="extraSmall" />

            <ShareLink
                variant="extraSmall"
                url="http://sears.com.mx/mesaderegalos/123456789/anabel-y-enrique"
            />
          </div>
      )}
      </div>
      {/* fin seccion botones subir foto,QR y compartir mobile */}

      <div>
        {/* Foto Evento */}
        <div className={styles.TableHeroMobile} style={{ backgroundImage: `url(${image})`,}} />
        { /* Icono Evento */}
        <div className={styles.iconevento2}>
          <div className={classNames( styles.TableHeroMobile_icon )}>
            {icon && <img src={icon} alt={eventName} />}
          </div>
        </div>
        {readOnly && (
          <div className={styles.divnew}>
            <div className='text-center'>
                <h1>
                  {tableName}
                </h1>
            </div>
          </div>
        )}
        {readOnly && (
          <div className={styles.divnew2}>
            <div className="text-center">
                <h6> {date} </h6>
            </div>
          </div>
        )}  
      </div>
      

    </>
  );
};

const mapStateToProps = (state) => ({
  tableInfo: state.giftTable.giftTableInfo.data,
  eventTypes: state.catalogs.flatEventTypes || [],
});

export default withStore({ mapStateToProps })(
  withFormik({ mapPropsToValues: () => ({}) })(TableHeroMobile)
);
